module.exports = __webpack_public_path__ + "img/profile-pic-gym.8f8e0cc3.jpg";